<template>
  <v-card>
    <v-card-title class="font-weight-light">
      Share Waybill
      <v-spacer></v-spacer>
      <v-btn
        @click="$emit('closed')"
        color="red lighten-5 red--text"
        rounded
        depressed
      >
        {{ $t("main.close") }}
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col>
          <v-chip color="blue lighten-5 blue--text">
            {{ $t("invoice.invoice_number") }}: {{ invoice.invoice_number }}
          </v-chip>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12">
          <v-tabs v-model="activeTab" centered>
            <v-tab> Email </v-tab>
            <v-tab> SMS </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-form ref="emailForm" v-model="emailFormValid">
            <v-row class="mt-4">
              <v-col cols="12">
                <h3 class="font-weight-light mb-3">Share Waybill via Email</h3>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="emailData.email"
                  :rules="emailRules"
                  label="Recipient Email"
                  outlined
                  type="email"
                  required
                  :value="invoice.customer.business_email"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="emailData.message"
                  label="Message (Optional)"
                  outlined
                  rows="3"
                  auto-grow
                  placeholder="Add a custom message to accompany the waybill..."
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>

        <v-tab-item>
          <v-form ref="smsForm" v-model="smsFormValid">
            <v-row class="mt-4">
              <v-col cols="12">
                <h3 class="font-weight-light mb-3">Share Waybill via SMS</h3>
              </v-col>

              <v-col cols="12">
                <phone-number-input
                  @input="(phone) => (smsData.recipient_number = phone)"
                  :default_number="invoice.customer.business_phone"
                ></phone-number-input>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <v-card-actions>
      <v-btn
        @click="sendWaybill"
        color="blue darken-4"
        dark
        block
        rounded
        x-large
        depressed
        :disabled="!isFormValid"
        :loading="sending"
      >
        Share Waybill
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PhoneNumberInput from "../agents/PhoneNumberInput.vue";

export default {
  name: "SendWaybillComponent",
  components: {
    PhoneNumberInput,
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  emits: ["closed", "success"],
  data() {
    return {
      activeTab: 0,
      sending: false,
      emailFormValid: false,
      smsFormValid: false,
      emailData: {
        email: "",
        message: "",
      },
      smsData: {
        recipient_number: "",
      },
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
    };
  },
  computed: {
    isFormValid() {
      if (this.activeTab === 0) {
        return this.emailFormValid && this.emailData.email;
      } else {
        return this.smsFormValid && this.smsData.recipient_number;
      }
    },
  },
  mounted() {
    if (this.invoice.customer.business_email) {
      this.emailData.email = this.invoice.customer.business_email;
    }
  },
  methods: {
    async sendWaybill() {
      if (!this.isFormValid) {
        return;
      }

      this.sending = true;

      try {
        if (this.activeTab === 0) {
          await this.sendViaEmail();
        } else {
          await this.sendViaSMS();
        }

        this.$emit("success");
        this.$emit("closed");
      } catch (error) {
      } finally {
        this.sending = false;
      }
    },

    async sendViaEmail() {
      const response = await axios.post(
        `/api/send-invoice-waybill/${this.invoice.uuid}/email`,
        {
          email: this.emailData.email,
          message: this.emailData.message,
        }
      );
      return response.data;
    },

    async sendViaSMS() {
      const response = await axios.post(
        `/api/send-invoice-waybill/${this.invoice.uuid}/sms`,
        {
          recipient_number: this.smsData.recipient_number,
        }
      );
      return response.data;
    },
  },
};
</script>

<style scoped>
.v-tabs-items {
  background-color: transparent;
}
</style>
